import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { PackageType } from '../_models/package_type';
import { MessService } from '../_services/mess-service.service';
import { PackageTypesService } from '../_services/package-types.service';

@Component({
  selector: 'app-package-types',
  templateUrl: './package-types.component.html',
})
export class PackageTypesComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  packageTypes: PackageType[];

  subscriptions: Subscription[] = [];

  constructor(
    private packageTypesService: PackageTypesService,
    private confirmationService: ConfirmationService,
    private messService: MessService
  ) {}

  // * lifecycles
  ngOnInit(): void {
    this.updatePackageList();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // * Edit/Delete === //
  onEditPackageType(packageData: PackageType) {
    this.packageTypesService.updatePackageTypeData.next(packageData);
  }

  onDeletePackageType(event: Event, packageTypeId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete tip?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.packageTypesService.deletePackageType(packageTypeId).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Obrisali ste tip.',
              });
              this.updatePackageList();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }

  // * Update list after delete === //
  private updatePackageList() {
    this.loading = true;
    this.subscriptions.push(
      this.packageTypesService
        .getAllPackageTypes()
        .subscribe((responseData) => {
          this.packageTypes = responseData;
          this.loading = false;
        })
    );
  }
}
